<script>
  let { cssClass, items } = $props();
 function show(i) {
   let empty = 0;
   i.forEach(e => {
     if (e.c == "") empty++;
   });
   return empty == i.length ? false : true;
 }
</script>
{#if show(items.c)}
<div class="{cssClass}">
  <h3>{items.t}</h3>
  <ul>
  {#each items.c as item}
    {#if item.c}
    <li class="{'item-' + item.n}"><div class="data-title">{item.t}</div><div class="data-value">{@html item.c}</div></li>
    {/if}
  {/each}
  </ul>
</div>
{/if}